module.exports = __webpack_public_path__ + "img/logo_square.2c271c21.png";